export const TIERS = [
    {
        id: "resume",
        name: "Slate Resume",
        price: 199,
        priceLabel: "$199",
        tagline: "Get the interview.",
        highlight: false,
        deliverables: [
            "JD-tailored, ATS-optimized resume",
            "Matching cover letter, written in your voice",
            "One revision round within 5 business days",
            "Delivered in Word and PDF",
        ],
        cta: "Choose Resume",
    },
    {
        id: "kit",
        name: "Slate Interview Kit",
        price: 349,
        priceLabel: "$349",
        tagline: "Walk in over-prepared.",
        highlight: false,
        deliverables: [
            "30-60-90 day plan for the role",
            "Hiring manager deep dive",
            "Interview prep guide",
            "Mock Q&A script in your voice",
            "Competitive intel one-pager",
            "Thank-you email templates",
        ],
        cta: "Choose Interview Kit",
    },
    {
        id: "campaign",
        name: "Slate Campaign",
        price: 499,
        priceLabel: "$499",
        tagline: "The full application-to-offer system.",
        highlight: true,
        badge: "Bestseller",
        deliverables: [
            "Everything in Slate Resume",
            "Everything in Slate Interview Kit",
            "One revision round across both",
            "Custom thank-you for the specific hiring manager",
            "Priority delivery — 48 hours",
        ],
        cta: "Start My Campaign",
    },
    {
        id: "executive",
        name: "Slate Executive",
        price: 1499,
        priceLabel: "$1,499",
        tagline: "For an active search.",
        highlight: false,
        deliverables: [
            "Unlimited campaigns for 3 months",
            "Panel-round prep briefs",
            "Salary negotiation playbook",
            "First-90-days onboarding plan on offer",
            "Direct line for same-day questions",
        ],
        cta: "Choose Executive",
    },
];

export const FUNNEL_STEPS = [
    {
        n: "01",
        label: "Application",
        title: "A resume the system actually reads.",
        body: "We rebuild your resume against the specific job description — language, structure, keywords, evidence. ATS-optimized without sounding like a robot.",
    },
    {
        n: "02",
        label: "Interview",
        title: "A kit built for the people across the table.",
        body: "30-60-90 plan, hiring manager deep dive, mock Q&A in your voice, competitive intel. You walk in knowing the room.",
    },
    {
        n: "03",
        label: "Offer",
        title: "Follow-ups that close the loop.",
        body: "Thank-you templates tailored to each interviewer. Salary-negotiation framing. A first-90-days plan when the offer lands.",
    },
];

export const FAQS = [
    {
        q: "How is Slate different from a resume builder?",
        a: "Resume builders give you a template. Slate gives you a campaign — a JD-tailored resume, a hiring-manager-specific interview kit, and follow-ups for the actual people you're meeting with. Built for senior leaders who don't have time to assemble it themselves.",
    },
    {
        q: "Who is Slate for?",
        a: "Director, VP, and SVP candidates in financial services and other industries — including people crossing into a new sector. If your next role pays six figures and the interview process has more than two rounds, Slate is built for you.",
    },
    {
        q: "How long does it take?",
        a: "Slate Resume: 3–5 business days. Slate Interview Kit: 3–5 business days. Slate Campaign: priority delivery in 48 hours from intake. Slate Executive: same-day turnaround on most requests inside the 3-month window.",
    },
    {
        q: "How does it stay in my voice?",
        a: "Every kit is built from a short kickoff questionnaire plus your current resume and writing samples. We don't replace your voice with a template — we sharpen it. Most clients say their thank-you emails sounded like them, only better.",
    },
    {
        q: "Do you offer revisions?",
        a: "Yes. Every tier includes at least one round of revisions. Slate Executive includes unlimited revisions for the active 3-month window.",
    },
    {
        q: "Will my information stay confidential?",
        a: "Always. We never share your resume, target companies, or interview details with anyone. Marketing case studies use anonymized companies and a fictional persona.",
    },
    {
        q: "What happens after I submit the intake form?",
        a: "You'll get a personal email within one business day with a secure payment link and a short kickoff questionnaire. Delivery starts the moment payment is confirmed.",
    },
];

export const INTERVIEW_STAGES = [
    { value: "exploring", label: "Just exploring — no specific role yet" },
    { value: "applied", label: "Applied, waiting to hear back" },
    { value: "recruiter_screen", label: "Recruiter screen scheduled or completed" },
    { value: "hiring_manager", label: "Hiring manager round" },
    { value: "panel_or_final", label: "Panel or final round" },
    { value: "offer_negotiation", label: "Offer / negotiation stage" },
];

export const MAGGIE_STORY = {
    name: "Maggie Sullivan",
    title: "Senior Director, Commercial Banking → VP, Wealth Management",
    quote:
        "I'd been a senior leader for 20+ years. I knew how to do the job. What I didn't have was time to translate that into a resume the right way, then build interview prep for three different firms in 60 days. Slate gave me all of it — in my voice. Recruiters started calling within a week.",
    metrics: [
        { value: "3", label: "Interviews in 60 days" },
        { value: "48h", label: "Delivery on each kit" },
        { value: "1", label: "Resume that finally cleared the ATS" },
    ],
    firms: [
        "A top-10 wealth management firm",
        "A leading RIA platform",
        "A global money-center bank",
    ],
};
